import React from 'react'
import { Form } from 'react-bootstrap'
import DatePicker from 'react-datepicker'

const FormDatePicker = ({label, ...rest}) => {
  return ( 
    <Form.Group>
        <Form.Label>{label} {rest.required && <span className="text-danger">*</span>}</Form.Label>
        <DatePicker {...rest} />
    </Form.Group>
  )
}

export default FormDatePicker
